"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OSMO_COSMO_CHANNEL = exports.COSMO_OSMO_CHANNEL = exports.OSMOSIS_PRECISION = exports.MAX_SWAPPER_SELL = exports.DEFAULT_SOURCE = void 0;
const api_1 = require("../../../api");
exports.DEFAULT_SOURCE = [{ name: api_1.SwapperName.Osmosis, proportion: '1' }];
exports.MAX_SWAPPER_SELL = '100000000000000000000000000';
exports.OSMOSIS_PRECISION = 6;
exports.COSMO_OSMO_CHANNEL = 'channel-141';
exports.OSMO_COSMO_CHANNEL = 'channel-0';
